export default "__VITE_ASSET__CTWtdt9B__"